"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CriterionHelper = /** @class */ (function () {
    function CriterionHelper() {
    }
    CriterionHelper.ifNumber = function (value) {
        if (typeof value === 'string' && value.length > 0) {
            return (Number.isFinite(+value) ? +value : value);
        }
        return value;
    };
    CriterionHelper.ifNumbers = function (values) {
        if (Array.isArray(values)) {
            values.forEach(function (value, index, items) {
                items[index] = CriterionHelper.ifNumber(value);
            });
        }
        return values;
    };
    CriterionHelper.isValidDate = function (value) {
        return value instanceof Date && !Number.isNaN(value.getTime());
    };
    CriterionHelper.ifDate = function (value) {
        if (typeof value === 'string' && value.length > 0) {
            var date = new Date(value);
            return CriterionHelper.isValidDate(date) ? date : value;
        }
        return value;
    };
    return CriterionHelper;
}());
exports.CriterionHelper = CriterionHelper;
//# sourceMappingURL=criterion-helper.js.map